import http, { addTokenAndKeyParams } from '@/utils/http'

export const getUserProtocol = data => {
  return http({
    url: '/gold/getStableGoldRecordForProtocol',
    params: addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}